

import React, { useState } from 'react';
const ProductMaterial = () => {
  const [formData, setFormData] = useState({
    product_id: "",
    material_id: "",
    quantity: "",
    unit: "",
    wastage_percent: "",
    cost_per_unit: "",
    total_cost: "",
    machine: "",
    operation: "",
    operation_time: "",
    version: "",
    is_default: "",
    status: "",
    approved_at: "", 
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userData = localStorage.getItem("user");
    let token = null;

    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        token = parsedUser?.access_token;
      } catch (error) {
        console.error("Failed to parse user data:", error);
      }
    }

    if (!token) {
      alert("Token not found. Please login first.");
      return;
    }

    const payload = {
      product_id: formData.product_id,
      material_id: formData.material_id,
      quantity: Number(formData.quantity),
      unit: formData.unit,
      wastage_percent: Number(formData.wastage_percent),
      cost_per_unit: Number(formData.cost_per_unit),
      total_cost: Number(formData.total_cost),
      machine: formData.machine,
      operation: formData.operation,
      operation_time: Number(formData.operation_time),
      version: formData.version,
      is_default: formData.is_default === "yes" ? 1 : 0,
      status: formData.status,
      approved_at: formData.approved_at
        ? new Date(formData.approved_at).toISOString()
        : null,
    };

    try {
      const response = await fetch(
        "https://peachpuff-toad-230421.hostingersite.com/api/bom/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const text = await response.text();
      console.log("Server raw response:", text);

      let result;
      try {
        result = JSON.parse(text);
      } catch (err) {
        throw new Error("Server response is not valid JSON");
      }

      if (!response.ok) {
        throw new Error(result.message || "Failed to submit");
      }

      alert("Submitted successfully!");
      console.log(result);

      // Reset form
      setFormData({
        product_id: "",
        material_id: "",
        quantity: "",
        unit: "",
        wastage_percent: "",
        cost_per_unit: "",
        total_cost: "",
        machine: "",
        operation: "",
        operation_time: "",
        version: "",
        is_default: "",
        status: "",
        approved_at: "",
      });

    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center " style={{ background: "#EEF2F8" }}>
      <div className="col-md-10 bg-white p-5 shadow rounded-4 mt-4 mb-4">
        <h3 className="text-center mb-4">Add Product Material Details</h3>
        <form className="row g-3" onSubmit={handleSubmit}>
          <div className="col-md-6">
            <label className="form-label">Product ID</label>
            <input type="text" name="product_id" className="form-control" value={formData.product_id} onChange={handleChange} />
          </div>
          <div className="col-md-6">
            <label className="form-label">Material ID</label>
            <input type="text" name="material_id" className="form-control" value={formData.material_id} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Quantity</label>
            <input type="number" name="quantity" className="form-control" value={formData.quantity} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Unit</label>
            <input type="text" name="unit" className="form-control" value={formData.unit} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Wastage (%)</label>
            <input type="number" name="wastage_percent" className="form-control" value={formData.wastage_percent} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Cost Per Unit</label>
            <input type="number" name="cost_per_unit" className="form-control" value={formData.cost_per_unit} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Total Cost</label>
            <input type="number" name="total_cost" className="form-control" value={formData.total_cost} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Machine</label>
            <input type="text" name="machine" className="form-control" value={formData.machine} onChange={handleChange} />
          </div>
          <div className="col-md-6">
            <label className="form-label">Operation</label>
            <input type="text" name="operation" className="form-control" value={formData.operation} onChange={handleChange} />
          </div>
          <div className="col-md-6">
            <label className="form-label">Operation Time (min)</label>
            <input type="number" name="operation_time" className="form-control" value={formData.operation_time} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Version</label>
            <input type="text" name="version" className="form-control" value={formData.version} onChange={handleChange} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Is Default</label>
            <select name="is_default" className="form-select" value={formData.is_default} onChange={handleChange}>
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">Status</label>
            <input type="text" name="status" className="form-control" value={formData.status} onChange={handleChange} />
          </div>
          <div className="col-md-6">
            <label className="form-label">Approved At</label>
            <input type="datetime-local" name="approved_at" className="form-control" value={formData.approved_at} onChange={handleChange} />
          </div>
          <div className="col-12 text-center mt-4">
            <button type="submit" className="btn btn-primary px-5">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProductMaterial;
